import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided.');
      return;
    }
    verifyEmail(token);
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      const res = await axios.post(`${API}/auth/verify-email`, { token });
      setStatus('success');
      setMessage(res.data.message || 'Email verified successfully!');
    } catch (e) {
      setStatus('error');
      setMessage(e.response?.data?.detail || 'Verification failed. The link may have expired.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center" data-testid="verify-email-page">
        {status === 'verifying' && (
          <>
            <Loader2 size={48} className="animate-spin text-brand-blue mx-auto mb-4" />
            <h2 className="text-xl font-bold text-gray-900 mb-2">Verifying Your Email</h2>
            <p className="text-gray-500 text-sm">Please wait...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle size={48} className="text-green-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-gray-900 mb-2">Email Verified!</h2>
            <p className="text-gray-500 text-sm mb-6">{message}</p>
            <button
              onClick={() => navigate('/agent/login')}
              className="px-6 py-3 bg-brand-blue text-white rounded-lg font-semibold text-sm hover:bg-blue-700 transition"
              data-testid="go-to-login-btn"
            >
              Go to Login
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle size={48} className="text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-gray-900 mb-2">Verification Failed</h2>
            <p className="text-gray-500 text-sm mb-6">{message}</p>
            <button
              onClick={() => navigate('/agent/login')}
              className="px-6 py-3 bg-brand-blue text-white rounded-lg font-semibold text-sm hover:bg-blue-700 transition"
              data-testid="back-to-login-btn"
            >
              Back to Login
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
